"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetDashboardRuntime = exports.resetDashboardHandler = void 0;
var tslib_1 = require("tslib");
var metaSelectors_1 = require("../../store/meta/metaSelectors");
var effects_1 = require("redux-saga/effects");
var dashboard_1 = require("../../events/dashboard");
var dateFilterConfigSelectors_1 = require("../../store/dateFilterConfig/dateFilterConfigSelectors");
var configSelectors_1 = require("../../store/config/configSelectors");
var stateInitializers_1 = require("./common/stateInitializers");
var redux_batched_actions_1 = require("redux-batched-actions");
var uniqWith_1 = tslib_1.__importDefault(require("lodash/uniqWith"));
var sdk_model_1 = require("@gooddata/sdk-model");
var insightResolver_1 = require("../../utils/insightResolver");
var insightReferences_1 = require("./common/insightReferences");
function resetDashboardHandler(ctx, cmd) {
    var data;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(resetDashboardFromPersisted, ctx)];
            case 1:
                data = _a.sent();
                return [4 /*yield*/, effects_1.put(redux_batched_actions_1.batchActions(data.batch, "@@GDC.DASH/RESET"))];
            case 2:
                _a.sent();
                return [2 /*return*/, dashboard_1.dashboardWasReset(ctx, data.persistedDashboard, cmd.correlationId)];
        }
    });
}
exports.resetDashboardHandler = resetDashboardHandler;
function resetDashboardRuntime(ctx, cmd) {
    var data;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(resetDashboardFromPersisted, ctx)];
            case 1:
                data = _a.sent();
                return [2 /*return*/, {
                        batch: redux_batched_actions_1.batchActions(data.batch, "@@GDC.DASH/RESET"),
                        reset: dashboard_1.dashboardWasReset(ctx, data.persistedDashboard, cmd.correlationId),
                    }];
        }
    });
}
exports.resetDashboardRuntime = resetDashboardRuntime;
function resetDashboardFromPersisted(ctx) {
    var persistedDashboard, batch, insightRefsFromWidgets, uniqueInsightRefsFromWidgets, resolvedInsights, settings, effectiveConfig, resolvedInsightsValues, dateFilterConfig;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(metaSelectors_1.selectPersistedDashboard)];
            case 1:
                persistedDashboard = _a.sent();
                batch = [];
                if (!persistedDashboard) return [3 /*break*/, 6];
                insightRefsFromWidgets = insightReferences_1.insightReferences(persistedDashboard.layout);
                uniqueInsightRefsFromWidgets = uniqWith_1.default(insightRefsFromWidgets, sdk_model_1.areObjRefsEqual);
                return [4 /*yield*/, effects_1.call(insightResolver_1.resolveInsights, ctx, uniqueInsightRefsFromWidgets)];
            case 2:
                resolvedInsights = _a.sent();
                return [4 /*yield*/, effects_1.select(configSelectors_1.selectSettings)];
            case 3:
                settings = _a.sent();
                return [4 /*yield*/, effects_1.select(dateFilterConfigSelectors_1.selectEffectiveDateFilterConfig)];
            case 4:
                effectiveConfig = _a.sent();
                resolvedInsightsValues = Array.apply(void 0, tslib_1.__spread(resolvedInsights.resolved.values()));
                return [4 /*yield*/, effects_1.call(stateInitializers_1.actionsToInitializeExistingDashboard, ctx, persistedDashboard, resolvedInsightsValues, settings, effectiveConfig)];
            case 5:
                batch = _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, effects_1.select(configSelectors_1.selectDateFilterConfig)];
            case 7:
                dateFilterConfig = _a.sent();
                batch = stateInitializers_1.actionsToInitializeNewDashboard(dateFilterConfig);
                _a.label = 8;
            case 8: return [2 /*return*/, {
                    batch: batch,
                    persistedDashboard: persistedDashboard,
                }];
        }
    });
}
//# sourceMappingURL=resetDashboardHandler.js.map